/** @format */

import {ScatterCollection} from '../../models/scatters';

export interface NoteWithDate {
  noteDate: string;
}

const getNotesCollection = <V extends NoteWithDate>(data: ReadonlyArray<V>): ScatterCollection => {
  return data.reduce<ScatterCollection>((acc, log) => {
    const date = log.noteDate;

    if (acc[date]) {
      acc[date] += 1;
    } else {
      acc[date] = 1;
    }

    return acc;
  }, {});
};

export {getNotesCollection};
